goog.provide('el8.app.settings.reactTab');

/**
 * @param {string} containerId - the ID of the container. This will be set on the
 * container element so React knows where to render the tab content.
 * @param {string} renderFnName - the name of the render function exported by
 * settings/entry.js that renders this tab's content.
 */
el8.app.settings.reactTab = function(options) {
  return (function() {
    var that = {};
    var $container;

    that = {
      init: function(_container) {
        $container = _container;
        $container.attr('id', options.containerId);
      },
      showTabFn: function() {
        $container.parent().css({
          border: 'none',
          borderRadius: 0,
          padding: 0,
          backgroundColor: 'inherit'
        });

        el8React[options.renderFnName](options.containerId, options.props);

        document.getElementById('settings-container').scrollTo(undefined, 0);
      },
      hideTabFn: function() {
        if ($container) {
          $container.parent().css({
            border: '1px solid #ccc',
            borderRadius: 5,
            padding: '15px 30px 30px',
            backgroundColor: '#fff'
          });
        }
      }
    };

    return that;
  })();
}
